var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAdd3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    "data-name": "Component 239 \\u2013 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(240,102,73,0.1)",
    stroke: "#ec6321",
    "data-name": "Rectangle 5716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17478"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17291"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17290"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17289"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ec6321",
    "data-name": "Icon ionic-ios-cube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.065 43.799-21.368-9.58a1.658 1.658 0 0 0-1.349 0l-21.376 9.58a1.003 1.003 0 0 0-.048 1.766l21.32 11.225a1.625 1.625 0 0 0 1.55 0l21.319-11.225a1.003 1.003 0 0 0-.048-1.766Z",
    "data-name": "Path 12200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.903 83.574 21.485-11.368a.964.964 0 0 0 .43-.81V49.337a.89.89 0 0 0-1.276-.848L66.055 59.56a.942.942 0 0 0-.51.848v22.345a.9.9 0 0 0 1.358.821z",
    "data-name": "Path 12201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.204 49.335v22.047a.964.964 0 0 0 .43.81l21.485 11.369a.879.879 0 0 0 1.337-.811V60.406a.942.942 0 0 0-.51-.849L40.48 48.488a.892.892 0 0 0-1.276.847z",
    "data-name": "Path 12202"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17295"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ec6321",
    "data-name": "Icon ionic-ios-add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.03 53.216a13.484 13.484 0 0 1-9.599-3.975 13.484 13.484 0 0 1-3.975-9.598c0-3.626 1.412-7.035 3.975-9.598a13.484 13.484 0 0 1 9.598-3.975c3.626 0 7.035 1.412 9.598 3.975a13.484 13.484 0 0 1 3.975 9.598c0 3.626-1.412 7.035-3.975 9.598a13.484 13.484 0 0 1-9.598 3.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feefec",
    d: "M36.03 26.57c-3.493 0-6.777 1.36-9.245 3.828a12.988 12.988 0 0 0-3.829 9.245c0 3.493 1.36 6.776 3.829 9.244a12.988 12.988 0 0 0 9.244 3.829c3.493 0 6.776-1.36 9.245-3.829a12.988 12.988 0 0 0 3.828-9.244c0-3.493-1.36-6.776-3.828-9.245a12.988 12.988 0 0 0-9.245-3.828m0-1c7.774 0 14.073 6.3 14.073 14.073 0 7.774-6.299 14.073-14.073 14.073s-14.073-6.3-14.073-14.073c0-7.774 6.3-14.073 14.073-14.073Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#feefec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.504 45.618h-.954a.728.728 0 0 1-.727-.727v-4.043h-4.044a.728.728 0 0 1-.727-.727v-.955c0-.4.327-.727.727-.727h4.044v-4.043c0-.4.326-.727.727-.727h.954c.4 0 .727.326.727.727v4.043h4.043c.401 0 .727.327.727.727v.955c0 .4-.326.727-.727.727h-4.043v4.043c0 .4-.326.727-.727.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec6321",
    d: "M35.55 33.92a.477.477 0 0 0-.477.476v4.293h-4.294a.477.477 0 0 0-.477.477v.955c0 .263.214.477.477.477h4.294v4.293c0 .263.213.477.477.477h.954a.477.477 0 0 0 .477-.477v-4.293h4.293a.477.477 0 0 0 .477-.477v-.955a.477.477 0 0 0-.477-.477h-4.293v-4.293a.477.477 0 0 0-.477-.477h-.954m0-.5h.954c.539 0 .977.439.977.977v3.793h3.793c.539 0 .977.439.977.977v.955a.978.978 0 0 1-.977.977h-3.793v3.793a.978.978 0 0 1-.977.977h-.954a.978.978 0 0 1-.977-.977v-3.793h-3.794a.978.978 0 0 1-.977-.977v-.955c0-.538.439-.977.977-.977h3.794v-3.793c0-.538.438-.977.977-.977z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd3D);
export default __webpack_public_path__ + "static/media/ic-add-3d.e30c00a0413695018c81bf32030d7587.svg";
export { ForwardRef as ReactComponent };